import baseUrl from '@/config/url.js'
import { systemInfo } from '@/common/index.js'
import { versionNum } from '@/config/index.js'
import { centerInfo } from '@/api/user.js'
import { storeToRefs } from 'pinia'
import useStoreFun from '@/stores/index.js';
let loginLock = false // 防止重复进入登录页
const request = async config => {
  config.header = config.header || {
	  // #ifdef MP-WEIXIN
		source: 'miniApp',
		// #endif
		// #ifndef MP-WEIXIN
		source: 'h5',
		// #endif
		model: systemInfo.deviceModel,
		brand: systemInfo.deviceBrand,
		system: systemInfo.osVersion,
		version: versionNum,
		"bingo-token": uni.getStorageSync('bingo-token'),
	}
  !config.ContentType && (config.header['Content-Type'] = 'application/json')
  // get请求映射params参数
  if (config.params) {
    let url = config.url + '?' + tansParams(config.params)
    url = url.slice(0, -1)
    config.url = url
  }
  return new Promise((resolve, reject) => {
    uni.request({
      method: config.method || 'get',
      timeout: config.timeout ||  30000,
      url: config.baseUrl || baseUrl + config.url,
      data: config.data,
      header: config.header,
      dataType: 'json'
    }).then(response => {
      const code = response.data.code || 200
      const msg = response.data.message || '网络异常'
      if (code == 200) {
        resolve(response.data)
      } else {
		  if(code == 402) {
			// uni.navigateTo({
			// 	url: "/pageA/login/login"
			// })
			uni.showToast({ title: msg, icon: 'none' })
			signOut()
		  }else if(code == 401){
			login();
			clearStore();
		  }else if(code == 405){
			clearStore()
			uni.showModal({
				title: '',
				content: msg,
				showCancel: false,
				confirmText: '我知道了',
				success: function (res) {
					if (res.confirm) {
						console.log('用户点击确定');
					} else if (res.cancel) {
						console.log('用户点击取消');
					}
				}
			});
		  } else if (code == 100000) {
			centerInfo().then(res4 => {
				const { useUserStore } = useStoreFun()
				const { userInfo } = storeToRefs(useUserStore)
				userInfo.value = res4.data
			})
			uni.showModal({
				title: '',
				content: msg,
				showCancel: false,
				confirmText: '我知道了',
				success: function (res) {
					if (res.confirm) {
						console.log('用户点击确定');
						uni.reLaunch({
						    url: '/pages/index/index' // 替换为你的首页路径
						});
					} else if (res.cancel) {
						console.log('用户点击取消');
					}
				}
			});
		  }else if(code == 6102){// 商品不存在
			uni.showToast({ icon: 'none', title: msg, duration: 2000 })
			// uni.navigateBack();
			let allPages = getCurrentPages().length;
			if(allPages < 2) return;
			setTimeout(() => {
				let newPages = getCurrentPages().length;
				if(allPages == newPages){
					uni.navigateBack();
				}
				// uni.navigateBack();
			}, 800)
		  }else if(code == 5601){// 拼团失败
			reject(response)
		  } else{
			uni.showToast({ icon: 'none', title: msg, duration: 2000 })
			reject(response)  
		  }
        
      }
    }).catch(error => {
      reject(error)
    })
  })
}
function login() {
	if (loginLock == false) {
		// uni.navigateTo({url: '/pageA/login/login'})
		// #ifdef MP-WEIXIN
		uni.navigateTo({ url: '/pageA/login/login' })
		// #endif
		// #ifndef MP-WEIXIN
		uni.navigateTo({ url: '/pageA/login/bind' })
		// #endif
	}
	loginLock = true
	setTimeout(() => { loginLock = false }, 3000)
}
function clearStore() {
	uni.removeStorageSync('bingo-token')
	uni.removeStorageSync('store_user')
}
function signOut() {
	clearStore()
	login()
}
/**
* 参数处理
* @param params 参数
*/
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    var part = encodeURIComponent(propName) + "="
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']'
            var subPart = encodeURIComponent(params) + "="
            result += subPart + encodeURIComponent(value[key]) + "&"
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&"
      }
    }
  }
  return result
}

export default request
